import { render, staticRenderFns } from "./movieGenreForm.vue?vue&type=template&id=9c3526e8&"
import script from "./movieGenreForm.vue?vue&type=script&lang=js&"
export * from "./movieGenreForm.vue?vue&type=script&lang=js&"
import style0 from "./movieGenreForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports